import { render, staticRenderFns } from "./GoodsFinish.vue?vue&type=template&id=25d0d425&scoped=true&"
import script from "./GoodsFinish.vue?vue&type=script&lang=js&"
export * from "./GoodsFinish.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFinish.vue?vue&type=style&index=0&id=25d0d425&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d0d425",
  null
  
)

export default component.exports